<div class="calendar-dropdown">
    <div class="calendar-header">
        <h3 class="calendar-title">Calendar</h3>
        <button class="save-btn" (click)="onSave()">Save</button>
    </div>

    <div class="calendar-selectors">
        <div class="selector-wrapper" (click)="toggleMonthDropdown($event)">
            <div class="selected-value">{{ months[viewDate.getMonth()] }}</div>
            <img src="assets/icons/direction-down.svg" class="select-icon" [class.open]="isMonthDropdownOpen">

            <div class="custom-dropdown" *ngIf="isMonthDropdownOpen">
                <div class="dropdown-item" *ngFor="let month of months; let i = index"
                    [class.active]="i === viewDate.getMonth()" (click)="selectMonth(i)">
                    {{ month }}
                </div>
            </div>
        </div>
        <div class="selector-wrapper" (click)="toggleYearDropdown($event)">
            <div class="selected-value">{{ viewDate.getFullYear() }}</div>
            <img src="assets/icons/direction-down.svg" class="select-icon" [class.open]="isYearDropdownOpen">

            <div class="custom-dropdown" *ngIf="isYearDropdownOpen">
                <div class="dropdown-item" *ngFor="let year of years" [class.active]="year === viewDate.getFullYear()"
                    (click)="selectYear(year)">
                    {{ year }}
                </div>
            </div>
        </div>
    </div>

    <div class="calendar-grid">
        <div class="weekday" *ngFor="let day of daysOfWeek">{{ day }}</div>
        <div class="day" *ngFor="let day of calendarDays" [class.other-month]="!day.isCurrentMonth"
            [class.today]="day.isToday" [class.selected]="day.isSelected" (click)="selectDate(day)">
            {{ day.date.getDate() }}
        </div>
    </div>
</div>